import React, { Suspense } from 'react';

// Keep an on-demand dialog from suspending the entire shop while its chunk loads.
export default function lazyComponent(load, fallback = null) {
    const Component = React.lazy(load);
    return function LazyComponent(props) {
        return <Suspense fallback={fallback}><Component {...props} /></Suspense>;
    };
}
